<!--Header responsible for arrows-->
<app-generic-header
  [goBack]="saveChangesButton ? saveButton.bind(this) : exitButton.bind(this)"
  [variant]="
  pageParameters.firstSetup
    ? 'empty'
    : (saveChangesButton ? 'save' : 'back')
">
</app-generic-header>

<ion-content class="ion-padding">

  <div class="centralized">

    <div class="page-image">
      <ion-icon [src]="pageParameters.logoURL"></ion-icon>
    </div>

    <div class="page-name">
      {{ pageParameters.text }}
    </div>

    <div class="button-list" [class.expand]="hasLongLabels()">

      <div *ngFor="let aOption of this.pageParameters.options; let i=index">
          <ion-button value=aOption.value  
          [attr.fill]="newOption === aOption.value ? 'solid' : 'outline'"
          size="small"
          shape="round" 
          [ngClass]="{ 'unselected': newOption !== aOption.value }" 
          (click)="setNewOption(aOption.value)">
          {{ aOption.label }}
        </ion-button>
      </div>

      <div *ngIf="pageParameters.fieldName === 'gender2'" id="otherOptionInput">
        <ion-item class="otherOptionItem">
          <ion-input class="otherOptionInput" type="text" [(ngModel)] = "otherOptionInput" placeholder="{{'otherGenderMsgOptional' | translate}}" (focusout)="inputOtherOptionLostFocus()" (input)="showSaveButton()"></ion-input>
        </ion-item>
      </div>

    </div>

    <div class="next-buttons" [hidden]="userData[pageParameters.fieldName] === null">
      <ion-button fill="outline" mode= "md" class="back-button" (click)="backButton()" size="small" value="back"  shape="round">{{ 'backSurvey' | translate }}</ion-button>

      <ion-button color="secondary" mode= "md" (click)="nextButton()" size="small" value="next" shape="round">{{ 'nextSurvey' | translate }}</ion-button>
    </div>
  </div>

</ion-content>
